import React from 'react';

export function PrivacyPolicy(): React.JSX.Element {
  return (
    <div className="flex flex-col min-h-[50vh] p-4 max-w-3xl mx-auto">
      <h1>Privacy Policy</h1>
      <div className="text-medium-emphasis-font my-4 space-y-6">
        <p className="text-sm">Last Updated: 12/16/2025</p>

        <div>
          <p>
            <strong>1. Overview and Consent</strong>
            <br />
            {'This Privacy Policy explains how Proprio, Inc. collects, uses, and protects '}
            information when you use our Platform and related Services, including SMS communications.
          </p>
          <p className="mt-4">
            {"These items consist of our limited services we provide to you via Proprio's AI "}
            {'surgical data analytics platform. The platform is referred to collectively as '}
            the &quot;Services.&quot;
          </p>
          <p className="mt-4">
            {'By accessing or using the Services, you are consenting to our processing of the '}
            {'information described in this Privacy Policy. Information processed by the '}
            {'Services will be transferred, processed, and stored in accordance with United '}
            States state and federal law.
          </p>
        </div>

        <div>
          <p>
            <strong>2. Information We Collect</strong>
            <br />
            We may collect:
          </p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>Account Information: Name, email, phone number, role, and organization.</li>
            <li>Usage Data: Device information, log data, and activity within the Platform.</li>
            <li>Operational Data: Surgical case details, imaging, and video metadata.</li>
            <li>SMS Communication Data: Message content, timestamps, and delivery reports (as applicable).</li>
          </ul>
          <p className="mt-4">
            {'Proprio does not intentionally collect or store personally identifiable patient '}
            {'information unless specifically authorized by your institution under applicable '}
            data-sharing agreements.
          </p>
        </div>

        <div>
          <p>
            <strong>3. How We Use Your Information</strong>
            <br />
            We use collected information to:
          </p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>Provide and maintain the Services;</li>
            <li>Send alerts and notifications (including SMS);</li>
            <li>Improve analytics models and user experience;</li>
            <li>Ensure system security and compliance;</li>
            <li>Fulfill legal or contractual obligations.</li>
          </ul>
          <p className="mt-4">
            De-identified or aggregated data may be used for analytics, research, or benchmarking purposes.
          </p>
        </div>

        <p>
          <strong>4. SMS and Communication Preferences</strong>
          <br />
          {'By providing your mobile number, you consent to receive SMS messages as part of '}
          {'your use of the Platform. You can opt out at any time by replying STOP or managing '}
          {'preferences in your account. Opting out of SMS does not affect service-related '}
          communications via email or in-platform notifications.
        </p>

        <div>
          <p>
            <strong>5. Opt-Out and Data Retention</strong>
            <br />
            {'Proprio only collects information that is necessary to provide you with the '}
            {'Services. Because of this, the only way to opt out of information collection '}
            is by stopping your use of the Services.
          </p>
          <p className="mt-4">
            {'Proprio retains data only for as long as necessary to fulfill the purposes '}
            {'described above or as required by law. Aggregated, non-identifiable data may '}
            be retained indefinitely for analytics and research.
          </p>
        </div>

        <p>
          <strong>6. Data Security</strong>
          <br />
          {'Proprio employs encryption (in transit and at rest), access controls, and regular '}
          {'audits to safeguard your data. Despite these measures, no system can guarantee '}
          absolute security.
        </p>

        <div>
          <p>
            <strong>7. Sharing and Disclosure</strong>
            <br />
            Proprio does not sell, rent, or trade your information. We may share data with:
          </p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>Authorized partners under HIPAA-compliant Business Associate Agreements (BAAs);</li>
            <li>Service providers supporting platform operations (e.g., cloud hosting, SMS gateways); and</li>
            <li>Regulatory authorities, if required by law.</li>
          </ul>
          <p className="mt-4">
            All third parties must adhere to equivalent privacy and security standards.
          </p>
        </div>

        <div>
          <p>
            <strong>8. Your Rights</strong>
            <br />
            Depending on your jurisdiction, you may have rights to:
          </p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>Access, correct, or delete your information;</li>
            <li>Withdraw consent for communications; or</li>
            <li>File a complaint with a regulatory authority.</li>
          </ul>
          <p className="mt-4">
            Requests can be made by contacting DataApps@propriovision.com.
          </p>
        </div>

        <p>
          <strong>9. Changes to this Policy</strong>
          <br />
          {'Proprio may update this Privacy Policy periodically. Changes will be posted on '}
          {'this page with a revised "Last Updated" date. Any continued use by you of the '}
          {'Services after the posting of such modified Privacy Policy shall be deemed to '}
          {'indicate your agreement to such modified Privacy Policy. Accordingly, if at any '}
          {'time you do not agree to be subject to any modified Privacy Policy, you may no '}
          longer use the Services.
        </p>

        <div>
          <p>
            <strong>10. Contact</strong>
            <br />
            For questions or concerns about this Privacy Policy, please contact:
          </p>
          <p className="mt-2">
            Email: DataApps@propriovision.com
          </p>
          <p>
            Address: 111 W John St Suite 308, Seattle, WA 98119
          </p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
